import {
  useUserAttributes,
  useUserAuthSession,
} from '@npm-client-frontends/global-context'
import {
  CognitoGroups,
  audienceGroups,
  AudienceGroups,
  CognitoAttributes,
} from '@npm-client-frontends/client-frontends-shared-types'
import { useMemo } from 'react'

export const useUserCognitoGroups = (): {
  userCognitoGroups: CognitoGroups[]
  userAudienceGroups: AudienceGroups[]
} => {
  const { userCognitoGroups } = useUserAuthSession()
  const { intelOnly } = useUserAttributes()

  const userAudienceGroups = useMemo(() => {
    const groups: AudienceGroups[] = userCognitoGroups.filter(
      (group: AudienceGroups) => audienceGroups.includes(group),
    )
    if (intelOnly) {
      groups.push(CognitoAttributes.FeatureIntelOnly)
    }
    return groups as AudienceGroups[]
  }, [userCognitoGroups, intelOnly])

  return { userCognitoGroups, userAudienceGroups }
}
